import { combineReducers } from "redux";
import { i18nReducer } from "react-redux-i18n";
import alertReducer from "../reducers/alertReducer";
import languageReducer from "../reducers/languageReducer";

export default combineReducers({
  // specific reducers go here
  i18n: i18nReducer,
  alert: alertReducer,
  language: languageReducer,
});
